import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import Callout, { type CalloutVariant } from '@/components/UI/Callout';

interface InactiveStrategyCalloutProps {
    strategyId: number;
    /** What the inactive strategy means where the callout appears, e.g. for this subscription or this portfolio. */
    children: ReactNode;
    /** `error` where the inactive strategy prevents the action outright, e.g. subscribing a live portfolio. */
    variant?: Extract<CalloutVariant, 'warning' | 'error'>;
}

/**
 * Explains that a strategy is switched off globally and will not trade, with a link to the strategy
 * where it can be activated. Opens in a new tab so an open editor or dialog is not lost.
 */
const InactiveStrategyCallout = ({ strategyId, children, variant = 'warning' }: InactiveStrategyCalloutProps) => (
    <Callout title="This strategy is inactive and will not trade" variant={variant}>
        <div>{children}</div>
        <Link className="mt-2 inline-block text-primary hover:text-blue-400" target="_blank" to={`/user/tradingStrategy/${strategyId}`}>
            Open the strategy to activate it
        </Link>
    </Callout>
);

export default InactiveStrategyCallout;
